var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370.18 349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#c1d5d7;}.cls-3{fill:#341460;}.cls-4{fill:#fff;stroke:#231f20;stroke-miterlimit:10;stroke-width:7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.45,344.63a223.9,223.9,0,0,1-13.72,21.92q-7.43,10.6-15.84,20.47t-17.7,18.91A241.33,241.33,0,0,1,340.67,423a208.69,208.69,0,0,1-44.35,26.73,176.48,176.48,0,0,1-49.94,13.64l-6.86.83,6.47-2.43q20.6-7.72,40.92-16.28c13.53-5.7,27-11.59,40.22-18s26.32-13,38.9-20.62a204,204,0,0,0,18.25-12.26,94.63,94.63,0,0,0,8.35-7.11,40.82,40.82,0,0,0,6.89-8.42l.2.58q-47.55-19.51-94.06-41.44-23.27-11-46.17-22.62c-15.26-7.79-30.42-15.8-45.31-24.29S184.57,274,170.31,264.46c-7.13-4.78-14.12-9.77-20.89-15A208.5,208.5,0,0,1,130,232.47a109.61,109.61,0,0,1-8.61-9.65,58,58,0,0,1-6.94-11,26.61,26.61,0,0,1-2.84-12.72c.14-2.2.42-4.26.46-6.4.06-1.06.07-2.12.06-3.18s0-2.12-.1-3.18A43.22,43.22,0,0,0,109.6,174a30.19,30.19,0,0,0-2.72-5.71,29.14,29.14,0,0,0-3.81-5,36.15,36.15,0,0,0-10.29-7.39c-1.91-1-3.88-1.78-5.87-2.57s-4-1.52-6-2.42l.08-.18c2,.85,4,1.54,6,2.29s4,1.53,6,2.45a37,37,0,0,1,10.62,7.3,30.63,30.63,0,0,1,6.9,10.93,44.06,44.06,0,0,1,2.61,12.68,84,84,0,0,1-.27,12.9,25.21,25.21,0,0,0,2.83,12.06,56.75,56.75,0,0,0,6.87,10.63,107.54,107.54,0,0,0,8.57,9.42c12.2,11.92,26.16,21.92,40.32,31.46s28.89,18.3,43.77,26.73c29.79,16.84,60.32,32.37,91.2,47.16s62.07,28.95,93.61,42.26l.44.19-.24.4a42.73,42.73,0,0,1-7.08,8.54,95.51,95.51,0,0,1-8.43,7.14,203.94,203.94,0,0,1-18.36,12.23c-12.63,7.55-25.67,14.35-38.89,20.78s-26.59,12.53-40.08,18.36S260.3,458,246.57,463.3l-.39-1.59a178.91,178.91,0,0,0,49.44-13.61,207.24,207.24,0,0,0,44.11-26.34,263.57,263.57,0,0,0,37.37-35.42c5.63-6.5,11-13.21,16.09-20.17a222.78,222.78,0,0,0,14.09-21.64Z",
    transform: "translate(-80.82 -145.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-54,428",
    transform: "translate(-80.82 -145.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.6,372l-124.13,49,2.24-15.61,83.19,88.89-96.05-74.8a9,9,0,0,1,.92-14.84l1.32-.78,115-67.84Z",
    transform: "translate(-80.82 -145.33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.38,331.57,93.68,363.09l4.37-15.16,70.19,99.48L83.37,360.12a9,9,0,0,1,2.95-14.57l1.41-.59,123.18-51.4Z",
    transform: "translate(-80.82 -145.33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.34,348.13,199.69,462.59,192,448.84l120.11,19.9-121.75-.89a9,9,0,0,1-8.93-9.07,8.86,8.86,0,0,1,.64-3.27l.57-1.42L232.53,330.3Z",
    transform: "translate(-80.82 -145.33)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.62,302.58l-117-13.07,9.15-12.41,24.07,102.21-42-96.25a8.79,8.79,0,0,1,4.55-11.58,8.64,8.64,0,0,1,2.87-.71l1.73-.12,117.41-8.06Z",
    transform: "translate(-80.82 -145.33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.52,281.68l98.63-89.93,1.1-1a9,9,0,0,1,12.72.58,9.16,9.16,0,0,1,1.76,2.87L451,308,390.48,202.35l15.59,2.44L322.71,309Z",
    transform: "translate(-80.82 -145.33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.45,257.6,341.78,155l1-1.15a9,9,0,0,1,12.68-1.17,9.29,9.29,0,0,1,2.14,2.6L416.05,262,341.59,165.7l15.77.28-68.25,114.7Z",
    transform: "translate(-80.82 -145.33)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.22,289.06l133-11.34,1.49-.12a9,9,0,0,1,9.73,8.2,9.12,9.12,0,0,1-.34,3.35L394.16,405.78l16.28-120.66,10.87,11.43-129.58,32Z",
    transform: "translate(-80.82 -145.33)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.57,262.42l42.21-109.87.61-1.58a8.82,8.82,0,0,1,13.94-3.52L359,215.85l-90.62-53,14.54-5.1L261,273.35Z",
    transform: "translate(-80.82 -145.33)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.5,409.69l-3.4-25.14a3.38,3.38,0,0,0-5.71-2L243.27,419l10-29.3a3.38,3.38,0,0,0-4.61-4.44l-50.43,33,18-31.65a3.38,3.38,0,0,0-3.76-5.51l-49.54,22.89,29.8-43.78a3.38,3.38,0,0,0-3.1-5.57l-64.26,11,45.14-36.78a3.38,3.38,0,0,0-1.52-6.16L109.55,316l57.71-18.15a3.38,3.38,0,0,0,1-6.19l-52.65-31.25L173,267.13a3.38,3.38,0,0,0,3.14-5.63l-35.77-44.64,52.59,26.71a3.38,3.38,0,0,0,4.66-4.3l-17.43-54L219.64,228a3.38,3.38,0,0,0,5.87-2.36l3.49-56.9,27.67,58.5a3.37,3.37,0,0,0,6.31-.59l22.37-53.4,9.25,57.85a3.37,3.37,0,0,0,6.6-.09l21.71-38.23-4.09,60.82a3.38,3.38,0,0,0,6.27,1.46l17.35-30-8.07,56.09a3.38,3.38,0,0,0,5.06,3.59l24.81-15L335.5,316.56l23.29,8.65-31.37,18,5.13,31.13-22.79-9.6Z",
    transform: "translate(-80.82 -145.33)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.49,
    cy: 209.02,
    r: 25.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 224.81,
    cy: 178.21,
    r: 25.17
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 187.25,
    cy: 209.02,
    r: 9.77
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.57,
    cy: 178.21,
    r: 9.77
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpider);
export default __webpack_public_path__ + "static/media/spider.9e11b461.svg";
export { ForwardRef as ReactComponent };